import { Role } from 'auth';
import { withPrivateAccess } from '@/modules/auth/hocs/withPrivateAccess.tsx';
import { useCurrentUserQuery } from '@/modules/auth/queries/user.tsx';
import CommonStatistic from '@/modules/common/components/dashboard/CommonStatistic.tsx';
import { Meetings } from '@/modules/common/components/dashboard/Meetings.tsx';
import TaskCompletionComparison from '@/modules/common/components/dashboard/TaskCompletionComparison.tsx';
import UpcomingTasks from '@/modules/common/components/dashboard/UpcomingTasks.tsx';
import Forms from '@/modules/admin-dashboard/components/dashboard/Forms.tsx';
import RecentActivity from '@/modules/admin-dashboard/components/dashboard/RecentActivity.tsx';
import Registers from '@/modules/admin-dashboard/components/dashboard/Registers.tsx';
import ReportTemplates from '@/modules/admin-dashboard/components/dashboard/ReportTemplates.tsx';
import UpcomingTaskCalendarV2 from '@/modules/admin-dashboard/components/dashboard/UpcomingTaskCalendarV2.tsx';
import { CreateCustomChartEmptyState } from '@/modules/admin-dashboard/components/dashboard/custom-charts/CreateCustomChartEmptyState.tsx';
import CustomChart from '@/modules/admin-dashboard/components/dashboard/custom-charts/CustomChart.tsx';
import { useCustomChartsQuery } from '@/modules/admin-dashboard/queries/custom-charts.ts';
import { adminDashboardPaths } from '@/modules/admin-dashboard/routes.tsx';
import { PageLayout, Skeleton } from 'ui';

const Dashboard = () => {
  const { data } = useCurrentUserQuery();
  const { data: customChartsData, isLoading: isLoadingCustomCharts } = useCustomChartsQuery({});

  const customCharts = (customChartsData?.pages || []).flatMap(({ data }) => data);

  return (
    <PageLayout
      title={
        data?.user ? (
          <div className="text-[32px] font-semibold">Hello, {data.user?.first_name}</div>
        ) : (
          <Skeleton width={216} height={26} />
        )
      }
      headerBottomContent={
        <TaskCompletionComparison isLoading={false} pivotStatistic={undefined} />
      }
      headerClassname="!border-none"
    >
      <div className="flex flex-col gap-6">
        <CommonStatistic />
        <UpcomingTaskCalendarV2 />
        <div className="grid gap-6 w-full grid-cols-1 lg:grid-cols-2">
          <Meetings />
          <Registers />

          <UpcomingTasks creatable viewAllPath={adminDashboardPaths.static.tasks} />
          <Forms />

          <ReportTemplates />
          {customCharts.map(chart => (
            <CustomChart key={chart.id} chart={chart} />
          ))}
          {!isLoadingCustomCharts && <CreateCustomChartEmptyState />}
        </div>
        <RecentActivity />
      </div>
    </PageLayout>
  );
};

export default withPrivateAccess(Dashboard, Role.COMPLIANCE_ADMIN);
